import { formatDate } from '../../../V3/helpers/formatDate'

export function fuelExpenses() {
  return [
    {
      accessorKey: 'date',
      id: 'date',
      header: () => <span>Dato</span>,
      cell: ({ row }) => {
        const date = formatDate(row.original.date)
        return date ?? 'Ukjent'
      },
      meta: { alignmentType: 'date' },
    },
    {
      accessorKey: 'description',
      id: 'description',
      header: () => <span>Beskrivelse</span>,
      cell: ({ getValue }) => getValue() || 'Ukjent',
      meta: { alignmentType: 'string' },
    },
    {
      accessorKey: 'station',
      id: 'station',
      header: () => <span>Stasjon</span>,
      cell: ({ row }) => {
        const station = row.original.station
        return station?.toLowerCase() ?? 'Ukjent'
      },

      meta: { alignmentType: 'string' },
    },
    {
      accessorKey: 'price',
      id: 'price',
      header: () => <span>Pris</span>,
      cell: ({ row }) => {
        const totalPrice = row.original.price
        return totalPrice ? `${Number(totalPrice.toFixed(2)).toLocaleString('no')} NOK` : 'Ukjent'
      },
      meta: { alignmentType: 'string' },
    },
  ]
}
